<template>
<div>
  <Top />
  <div class="maindiv pdate-wrap  bg-gray">
    <Banner />
    <div class="mt180 bgw htmldiv">
      <banner-title />
      <div class="dtable">
        <table class="tcenter fs16">
          <thead>
          <tr class="fbold str prelative">
            <td>培训项目</td>
            <td>培训开始时间</td>
            <td>培训结束时间</td>
            <!-- <td>预约操作</td> -->
          </tr>
          </thead>
          <tbody>
          <tr v-for='(item,idx) in list' :key='idx'>
            <td>{{ item.name }}</td>
            <td>{{ item.start_dt }}</td>
            <td>{{ item.end_dt }}</td>

            <!-- <td> -->
              <!-- type_id =1 是普通的 type_id=3是特种工 -->
              <!-- router-link :to="item.type_id == 3 ? `/train/project/sign?id=${item.id}` : `/train/project/detail?id=${item.id}`" href="#" class="zbtn zbtn-bblue fs14 br25 trans3">
                立即报名</router-link -->
            <!-- </td> -->
          </tr>

          </tbody>
        </table>

      </div>
      <!--暂时放一下-->
      <div class="page tcenter">
        <Pagec v-if="total>0" :pagen="page" :size="size" :total="total" :pageClass="'page-blue'" @get-data="getData"/>
      </div>
    </div>

    <div class="ht30"></div>
  </div>
  <Bottom />
</div>
</template>

<script>
import Top from "../top";
import Banner from "../banner";
import Bottom from "../bottom";
import BannerTitle from "./title";
import Pagec from "../../index/page";
export default {
  name: "index",
  components:{
    Top,
    Banner,
    Bottom,
    BannerTitle,
    Pagec,
  },
  data() {
    return {
      list: [],
      'page': 1,
      'size': 10,
      'total': 0,
    }
  },
  created(){
    this.getData(1)
  },
  methods: {
    getData(page){
      var getParam = {};
      getParam['type'] = 1;
      //getParam['type'] = 2;
      getParam['page'] = page - 1;
      getParam['size'] = this.size;
      this.$request.get('training-skill/list', getParam, res => {
          if(res.status == 200){
            //console.log(res.data.data)
            this.list = res.data.data.noticeList;
            this.total = res.data.data.count;
          }
        }, err => {
            console.log(err)
        }
      )
    },
    formatDate(time) {
      if(!time)
        return '未定'
      else{
        var date = new Date(time)
        var dateTime = date.getTime() / 1000;
        return this.$request.date('Y年m月d日',date);
      }
    },
    formatDate2(time) {
      if(!time)
        return '未规定'
      else{
        var date = new Date(time)
        var dateTime = date.getTime() / 1000;
        return '截止' + this.$request.date('Y年m月d日',date);
      }
    }

  }
}
</script>

<style scoped>
  .dtable{padding: 40px 35px 80px;}
  .dtable table{width: 100%;max-height: 100px;border-collapse: collapse;}
  .dtable tbody tr{height: 52px;border-bottom: 1px solid #ddd;}
  .dtable .str{height: 45px;}
  .dtable .str td{position: sticky;top: 0;background: #f0f6ff;}
  .dtable .zbtn{padding: 5px 20px;}
</style>



// WEBPACK FOOTER //
// src/components/train/calendar/index.vue